import { render } from "./ReviewMyApp.vue?vue&type=template&id=ed453ec8&scoped=true"
import script from "./ReviewMyApp.vue?vue&type=script&lang=js"
export * from "./ReviewMyApp.vue?vue&type=script&lang=js"

import "./ReviewMyApp.vue?vue&type=style&index=0&id=ed453ec8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ed453ec8"]])

export default __exports__